import { TPanoramaVm } from "..";

export const PanoramaVm: TPanoramaVm = {
  phase: {
    position: [-3051073.4905346646, 4041622.284854461, 3865028.485831244],
    orientation: {
      heading: 0.978823452425793,
      pitch: -0.34326038565677863,
      roll: 0.0000044044506495311,
    },
  },
  //   baseModelPath: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/3d-tiles-merged/2024/tileset.json`,
  baseModelPath: `${process.env.REACT_APP_DATA_BASE_URL}/models/Manual/K-HQ/tileset.json`,
  items: [
    {
      index: 1,
      position: [127.052899, 37.5404523, 105.5],
      view: {
        position: [127.0534805, 37.5395436, 140],
        orientation: {
          heading: 330,
          pitch: -13,
          roll: 0,
        },
      },
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_1.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_1_1080p.jpg`,
    },
    {
      index: 2,
      position: [127.0528619, 37.5403614, 105],
      view: {
        position: [127.0533372, 37.5395817, 140],
        orientation: {
          heading: 330,
          pitch: -13,
          roll: 0,
        },
      },
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_2.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_2_1080p.jpg`,
    },
    {
      index: 3,
      position: [127.0527588, 37.5401092, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_3.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_3_1080p.jpg`,

      view: {
        position: [127.0536204, 37.5398859, 140],
        orientation: {
          heading: 290,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 4,
      position: [127.0526567, 37.5398594, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_4.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_4_1080p.jpg`,

      view: {
        position: [127.0536496, 37.5402577, 140],
        orientation: {
          heading: 245,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 5,
      position: [127.0526196, 37.5397659, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_5.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_5_1080p.jpg`,

      view: {
        position: [127.0537596, 37.5402292, 140],
        orientation: {
          heading: 245,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 6,
      position: [127.0527435, 37.5397356, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_6.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_6_1080p.jpg`,

      view: {
        position: [127.0537265, 37.5401481, 140],
        orientation: {
          heading: 245,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 7,
      position: [127.0530487, 37.5396556, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_7.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_7_1080p.jpg`,

      view: {
        position: [127.0533291, 37.5403417, 140],
        orientation: {
          heading: 200,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 8,
      position: [127.0533372, 37.5395817, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_8.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_8_1080p.jpg`,

      view: {
        position: [127.0528619, 37.5403614, 140],
        orientation: {
          heading: 150,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 9,
      position: [127.0534805, 37.5395436, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_9.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_9_1080p.jpg`,

      view: {
        position: [127.052899, 37.5404523, 140],
        orientation: {
          heading: 150,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 10,
      position: [127.0535255, 37.5396566, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_10.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_10_1080p.jpg`,

      view: {
        position: [127.0530423, 37.5404142, 140],
        orientation: {
          heading: 150,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 11,
      position: [127.0536204, 37.5398859, 108],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_11.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_11_1080p.jpg`,

      view: {
        position: [127.0527588, 37.5401092, 140],
        orientation: {
          heading: 110,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 12,
      position: [127.0537265, 37.5401481, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_12_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_12.JPG`,

      view: {
        position: [127.0527435, 37.5397356, 140],
        orientation: {
          heading: 50,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 13,
      position: [127.0537596, 37.5402292, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_13_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_13.JPG`,

      view: {
        position: [127.0526196, 37.5397659, 140],
        orientation: {
          heading: 50,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 14,
      position: [127.0536496, 37.5402577, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_14_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_14.JPG`,

      view: {
        position: [127.0526567, 37.5398594, 140],
        orientation: {
          heading: 50,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 15,
      position: [127.0533291, 37.5403417, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_15_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_15.JPG`,

      view: {
        position: [127.0530487, 37.5396556, 140],
        orientation: {
          heading: 15,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 16,
      position: [127.0530423, 37.5404142, 108],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_16_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_16.JPG`,

      view: {
        position: [127.0535255, 37.5396566, 140],
        orientation: {
          heading: 330,
          pitch: -13,
          roll: 0,
        },
      },
    },
    {
      index: 17,
      position: [127.0531896, 37.5399975, 150],
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상 뷰 사진_17_1080p.jpg`,
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panorama/250115_KP_HQ 옥상뷰 파노라마 사진_17.JPG`,

      view: {
        position: [127.0535552, 37.5408807, 165],
        orientation: {
          heading: 200,
          pitch: -13,
          roll: 0,
        },
      },
    },
  ],
};

export default { PanoramaVm };
